import { RouteParams } from 'universal-router';

export abstract class Page {
    public static render(params: RouteParams = {}): void {
        throw new Error('Not implemented yet.');
    }
}
